import React from "react";
import PropTypes from "prop-types";
import HeaderWithIcon from "../common/HeaderWithIcon";
import { vancouverFormat } from "../../lib/utils";
import styles from "../../styles/content.module.scss";

const ReferencesChapter = ({ references }) => {
  return (
    <div>
      <HeaderWithIcon icon={"file"} title={"References"} />
      <ol className={styles.referencesList}>
        {references.map(r => (
          <li key={r._id}>{vancouverFormat(r)}</li>
        ))}
      </ol>
    </div>
  );
};

ReferencesChapter.propTypes = {
  references: PropTypes.array.isRequired
};

export default ReferencesChapter;
